import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useSelector } from "react-redux";

import Sidebar from "./components/Sidebar/Sidebar";
import MainContent from "./components/MainContent/MainContent";
import "./App.css";

import Dashboard from "./pages/Dashboard";
import Addvehicle from "./pages/Vehicles/Addvehicle";
import VehicleList from "./pages/Vehicles/VehicleList";
import VehicleDetailsPage from "./pages/Vehicles/VehicleDetailsPage";
import EditVehicle from "./pages/Vehicles/EditVehicle";
import TicketList from "./pages/Tickets/TicketList";
import Login from "./pages/LoginPage";
import VahanDetailsPage from "./pages/Vehicles/VahanDetailsPage";
import UploadMedia from "./components/UploadMedia";
import AddEmployee from "./pages/Employees/AddEmployee";
import EmployeeList from "./pages/Employees/EmployeeList";
import AddYard from "./pages/Yards/AddYard";
import YardsListPage from "./pages/Yards/YardsListPage";
import EditEmployee from "./pages/Employees/EditEmployee";
import AddCase from "./pages/Cases/AddCase";
import CaseList from "./pages/Cases/CaseList";
import CaseDetails from "./pages/Cases/CaseDetails";
import EditCase from "./pages/Cases/EditCase";
import EditYard from "./pages/Yards/EditYard";
import AssignCases from "./pages/Cases/AssignCases";
import AgencyOnBoard from "./pages/Agnecy/AgencyOnBoard";
import { ValuationReport } from "./report/ValuationReport";
import PendingAgencies from "./pages/Agnecy/PendingAgencies";
import AgencyDetails from "./pages/Agnecy/AgencyDetails";
import ApprovedAgencies from "./pages/Agnecy/ApprovedAgencies";
import AddClient from "./pages/Client/AddClient";
import ClientList from "./pages/Client/ClientList";
import EditClient from "./pages/Client/EditClient";


function App() {
  const { isAuthenticated } = useSelector((state) => state.auth);

  return (
    <Router>
      <Routes>
        {/* 🔐 Protected Routes - Only accessible when authenticated */}
        <Route
          path="/*"
          element={
            isAuthenticated ? (
              <div className="app-container">
                <Sidebar />
                <div className="main-content-wrapper">
                  <Routes>
                    <Route path="/" element={<Dashboard />} />

                    <Route path="/auctions" element={<MainContent />}>
                      <Route index element={<VehicleList />} />
                      <Route path="list" element={<VehicleList />} />
                      <Route path="addAuction" element={<Addvehicle />} />
                      <Route path="get/:id?" element={<VehicleDetailsPage />} />
                      <Route
                        path="editAuction/:id?"
                        element={<EditVehicle />}
                      />
                    </Route>
                    <Route
                      path="/vahan-details"
                      element={<VahanDetailsPage />}
                    />
                    <Route path="/tickets" element={<MainContent />}>
                      <Route index element={<TicketList />} />
                      <Route path="list" element={<TicketList />} />
                    </Route>
                    <Route path="/employees" element={<MainContent />}>
                      <Route index element={<EmployeeList />} />
                      <Route path="add" element={<AddEmployee />} />
                      <Route path="list" element={<EmployeeList />} />
                      <Route path="edit/:id" element={<EditEmployee />} />
                    </Route>
                    <Route path="/yards" element={<MainContent />}>
                      <Route index element={<YardsListPage />} />
                      <Route path="addYard" element={<AddYard />} />
                      <Route path="edit/:id" element={<EditYard />} />
                      <Route path="list" element={<YardsListPage />} />
                    </Route>
                    <Route path="/clients" element={<MainContent />}>
                      <Route index element={<ClientList />} />
                      <Route path="add" element={<AddClient />} />
                      <Route path="list" element={<ClientList />} />
                      <Route path="edit/:id" element={<EditClient />} />
                    </Route>
                    <Route path="/cases" element={<MainContent />}>
                      <Route index element={<CaseList />} />
                      <Route path="view/:id" element={<CaseDetails />} />
                      <Route path="edit/:id" element={<EditCase />} />
                      <Route path="add" element={<AddCase />} />
                      <Route path="list" element={<CaseList />} />
                      <Route path="report/:id" element={<ValuationReport />} />
                      <Route path="AssignCasesList" element={<AssignCases />} />
                    </Route>
                    <Route path="/agencies" element={<MainContent />}>
                      <Route index element={<PendingAgencies />} />
                      <Route path="list" element={<ApprovedAgencies />} />
                      <Route path="pendingList" element={<PendingAgencies />} />
                      <Route
                        path="agency-details/:id"
                        element={<AgencyDetails />}
                      />
                    </Route>
                  </Routes>
                </div>
              </div>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* 🔓 Public Routes - Only accessible when NOT authenticated */}
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
        />
        <Route path="/UploadMedia" element={<UploadMedia />} />
        <Route path="/AgencyOnBoard" element={<AgencyOnBoard />} />
        <Route path="report/:id" element={<ValuationReport />} />
      </Routes>
    </Router>
  );
}

export default App;
